// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1Bk18","name":"ConsentHeader_name__2EDyb","birthday":"ConsentHeader_birthday__2DKeb","skeleton":"ConsentHeader_skeleton__pAmc3"};